import React from "react";
import "./Logo.css";
import LogoSecurity from "../../assets/Logo.png";

/**
 * Logo component to display the company logo image.
 *
 * This component renders a div container with an accessible label
 * and an image element displaying the company logo.
 *
 * @returns {JSX.Element} The company logo wrapped in a container div.
 */

export default function Logo() {
  return (
    <div className="logo" aria-label="Company Logo">
        {/* 
        The img element uses the imported PenzoLogo image.
        The alt attribute provides alternative text for screen readers and accessibility.
      */}
      <img src={LogoSecurity} alt="Company Logo" />
    </div>
  );
}
